import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "10px",
	height: "7px",
	viewBox: "0 0 10 7",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "Path"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "+-Symbols",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Icon/Check",
			transform: "translate(0.000000, -2.000000)",
			fill: "#717C7D",
			children: /* @__PURE__ */ _jsx("polygon", {
				id: "Path",
				transform: "translate(5.076695, 4.000000) rotate(45.000000) translate(-5.076695, -4.000000) ",
				points: "6.20525239 6.51471287 2.46284967 6.51471287 2.46284967 8 7.69053951 8 7.69053951 0 6.20525239 0"
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
